var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShopLisIcon001 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6H5C3.346 6 2 7.346 2 9V14C2 16.206 3.794 18 6 18H7.637C8.803 18 9.917 17.443 10.618 16.509C11.278 15.63 12.722 15.629 13.382 16.51C13.7301 16.9717 14.1804 17.3465 14.6976 17.605C15.2148 17.8635 15.7848 17.9987 16.363 18H18C20.206 18 22 16.206 22 14V9C22 7.346 20.654 6 19 6ZM7.5 13C6.119 13 5 12.328 5 11.5C5 10.672 6.119 10 7.5 10C8.881 10 10 10.672 10 11.5C10 12.328 8.881 13 7.5 13ZM16.5 13C15.119 13 14 12.328 14 11.5C14 10.672 15.119 10 16.5 10C17.881 10 19 10.672 19 11.5C19 12.328 17.881 13 16.5 13Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShopLisIcon001);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shop-lis-icon-001.2f939d67a9e4abf961d542f5a4ca22e1.svg";